module.exports = __webpack_public_path__ + "img/rewards-illustration-mobile.5adc8aff.png";